import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { hasError: false, error: null, component: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("Erreur d'affichage :", error, info?.componentStack);
    const component = (info?.componentStack || "")
      .split("\n")
      .map((l) => l.trim())
      .filter((l) => l.startsWith("at "))
      .slice(0, 3)
      .map((l) => l.replace(/^at /, "").trim())
      .join(" ← ");
    this.setState({ component });
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const detail = this.state.error
      ? String(this.state.error?.message || this.state.error)
      : "";
    return (
      <div
        data-testid="error-boundary"
        className="min-h-screen grid place-items-center bg-slate-50 px-6"
      >
        <div className="max-w-md w-full rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
          <h1 className="text-xl font-semibold text-slate-900">Une erreur est survenue</h1>
          <p className="mt-2 text-sm text-slate-600">
            L'affichage a été interrompu. Vos données sont bien enregistrées : rechargez la page
            pour reprendre.
          </p>
          {(detail || this.state.component) && (
            <p
              data-testid="error-boundary-detail"
              className="mt-4 rounded-lg border border-slate-200 bg-slate-50 p-3 text-left font-mono text-xs break-all text-slate-500"
            >
              {detail}
              {this.state.component ? `${detail ? " — " : ""}${this.state.component}` : ""}
            </p>
          )}
          <button
            type="button"
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            className="mt-6 inline-flex items-center justify-center rounded-full bg-blue-600 px-6 py-3 font-medium text-white transition-colors hover:bg-blue-700"
          >
            Recharger la page
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
